
angular.module('trainerWebApp.resources')
  .factory('customFieldsResource', ['$resource', 'errorHandler', function ($resource, errorHandler) {

    var CustomFieldsResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/user-custom-field');

    // Manage Custom Fields setup
    CustomFieldsResource.prototype.getCustomFields = function getCustomFields(accountId, resultCb, errorCb) {
      return CustomFieldsResource.get(resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    // Manage Custom Fields save
    CustomFieldsResource.prototype.save = function save(dto, resultCb, errorCb) {
      return CustomFieldsResource.save(dto, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    return new CustomFieldsResource;
  }]);
